import RenderManager from "../rendering/render-manager";

const stickerVisualizer = new THREE.SphereBufferGeometry(1, 16, 16);

class AssessmentSticker {
    constructor({ object, desiredPosition }) {
        const bbox = new THREE.Box3().setFromObject(object);
        const wPosition = object.getWorldPosition(new THREE.Vector3());
        const center = bbox.getCenter(new THREE.Vector3());

        this._bboxDelta = center.sub(wPosition);

        this._object = object;
        this._desiredPosition = new THREE.Vector3().copy(desiredPosition);

        (function () {
            const material = new THREE.MeshBasicMaterial({ color: 0xff00ff });
            const mesh = new THREE.Mesh(stickerVisualizer, material);

            mesh.position.copy(desiredPosition);
            mesh.scale.set(0.1, 0.1, 0.1);

            material.wireframe = true;

            object.parent.add(mesh);
        })();

        this._div = document.createElement("div");
        this._div.style.position = "absolute";
        this._div.style.backgroundColor = "rgba(255, 0, 0, 0.2)";
        this._div.style.pointerEvents = "none";
        this._div.style.top = 0;
        this._div.style.left = 0;
        this._div.style.borderRadius = "9999999999px";
        this._div.style.width = this._div.style.height = "10vmin";
        this._div.style.transform = "translate(-50%, -50%)";
        RenderManager.overlay2d.appendChild(this._div);

        this._div2 = document.createElement("div");
        this._div2.style.position = "absolute";
        this._div2.style.backgroundColor = "rgba(0, 255, 0, 0.2)";
        this._div2.style.pointerEvents = "none";
        this._div2.style.top = 0;
        this._div2.style.left = 0;
        this._div2.style.borderRadius = "9999999999px";
        this._div2.style.width = this._div2.style.height = "1vmin";
        this._div2.style.transform = "translate(-50%, -50%)";
        RenderManager.overlay2d.appendChild(this._div2);
    }

    get object() { return this._object; }

    update() {
        const v1 = new THREE.Vector3().copy(this._object.position).project(RenderManager.activeCamera);
        const v2 = new THREE.Vector3().copy(this._desiredPosition).project(RenderManager.activeCamera);
        const { width, height } = RenderManager.getSize();

        (() => {
            const xy = RenderManager.toScreenCoords(v2.x, v2.y);

            this._div.style.left = xy.x + "px";
            this._div.style.top = xy.y + "px";
        })();

        (() => {
            const xy = RenderManager.toScreenCoords(v1.x, v1.y);

            this._div2.style.left = xy.x + "px";
            this._div2.style.top = xy.y + "px";
        })();
    }

    plop() {
        this._object.position.copy(this._desiredPosition);
    }

    check() {
        const { width, height } = RenderManager.getSize();

        let v1 = new THREE.Vector3().copy(this._object.position).project(RenderManager.activeCamera);
        let v2 = new THREE.Vector3().copy(this._desiredPosition).project(RenderManager.activeCamera);

        v1 = RenderManager.toScreenCoords(v1.x, v1.y);
        v2 = RenderManager.toScreenCoords(v2.x, v2.y);

        const dt = v1.distanceToSquared(v2);

        if (dt < Math.pow(Math.min(width, height) * 0.1, 2)) this.plop();
    }
}

export default AssessmentSticker;
export { AssessmentSticker };